import { motion } from 'framer-motion'
import { Helmet } from 'react-helmet-async'
import Contact from '../components/Contact'

export default function ContactPage() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
    >
      <Helmet>
        <title>Contact | Ionic Errrrs Code</title>
        <meta name="description" content="Get in touch with Ionic Errrrs Code. We'd love to hear about your project and discuss how we can help bring your ideas to life." />
        <link rel="canonical" href="https://ionicerrrrscode.com/contact" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Ionic Errrrs Code" />
        <meta property="og:title" content="Contact | Ionic Errrrs Code" />
        <meta property="og:description" content="Get in touch with Ionic Errrrs Code. We'd love to hear about your project and discuss how we can help bring your ideas to life." />
        <meta property="og:url" content="https://ionicerrrrscode.com/contact" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Contact | Ionic Errrrs Code" />
        <meta name="twitter:description" content="Get in touch with Ionic Errrrs Code. We'd love to hear about your project and discuss how we can help bring your ideas to life." />
      </Helmet>
      <Contact />
    </motion.div>
  )
}
